import UsersList from "../../components/administation/users/UsersList";
import FormTitle from "../../components/helpers/FormTitle";
import GroupIcon from "@mui/icons-material/Group";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { Box, Button, FormGroup, TextField, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { BasicListContext } from "../../contexts/BasicListContext";
import BasicRadioGroup from "../../components/form/BasicRadioGoup";
import { _ACTIVE_RADIO_GROUP } from "../../utils/constants";
import AppRights from "../../services/AppRights";
import { _ROLES_BACK } from "../../utils/constants";

export const UserAdmin = () => {
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const { extraQueryParams, setExtraQueryParams } =
    useContext(BasicListContext);

  return (
    <>
      <AppRights
        roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CONTROLE_GESTION]}
      />
      <FormTitle title="Manage Users" />
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}>
        <Box
          width={"100%"}
          display={"flex"}
          gap={1}
          alignItems={"baseline"}
          sx={{
            borderBottom: "1px solid #ccc",
          }}>
          <GroupIcon />
          <Typography variant="h6" component="div">
            Users List
          </Typography>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}>
            <TextField
              id="outlined-basic"
              label="Find"
              variant="outlined"
              size="small"
              name="customFind"
              onBlur={(e) => {
                setExtraQueryParams({
                  ...extraQueryParams,
                  customFind: e.target.value ? e.target.value : null,
                });
              }}
            />
            <FormGroup
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                marginLeft: 2,
              }}>
              <BasicRadioGroup
                setExtraQueryParams={setExtraQueryParams}
                extraQueryParams={extraQueryParams}
                choices={_ACTIVE_RADIO_GROUP}
                defaultValue={extraQueryParams?.active}
                onChange={(e) => {
                  setExtraQueryParams({
                    ...extraQueryParams,
                    active: e.target.value,
                  });
                }}
              />
            </FormGroup>
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              title={"New User"}
              startIcon={<GroupAddIcon />}
              color="success"
              onClick={() => {
                // Modal create user
                setEditData(null);
                setShowModal(true);
              }}>
              {"New User"}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          width: "100%",
        }}>
        <UsersList
          editData={editData}
          setEditData={setEditData}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      </Box>
    </>
  );
};
